/* global translate */
import React from 'react'
import './poll_list_item.css';
const RxPollItem = global.rootRequire('components/shares/pollComponent/pollMessItem/poll_item').default
const { rxaget, stringToColour, rxChangeSlug, subString ,changeColorSVG,autoConvertTime } = global.rootRequire('classes/ulti')
const { checkNameContact, checkNameUser, changeColorAva } = global.rootRequire('classes/chat')

export const renderComponent = (vm) =>{
  let pollInfo = vm.props.pollInfo
  return(
    <div className='zlist-poll-item-place' onClick={() => {vm.choosePoll(pollInfo)}}>
      {
        vm.state.user_created &&
        <div className='zlist-poll-item-header'>
        {/* <div className='zpoll_item_creator'>
          <div className='group_contacts_item clearfix' >
            <div className='zgroup_avatar'>
              {vm.state.user_created.profile_url && (
                <img src={global.rxu.config.cdn_endpoint + vm.state.user_created.profile_url} alt=''
                  data-id={'userava' + vm.state.user_created.id} className='ava-useravatar images-static'
                  onError={e => { e.target.onerror = null; e.target.src = './images/default/static/avadefault.svg' }}
                />
              )}
              {!vm.state.user_created.profile_url && <span className='ava-span' style={{ background: `${changeColorAva(vm.state.user_created?.id?.toString())}` }} >
                {rxChangeSlug(checkNameUser(vm.state.user_created)).slice(0, 2).toUpperCase()}
              </span>}
            </div>
            <div className='zgroup_maininfo-contact'>
              <div className='newgroup_userinfo_place'> 
                {
                  (vm.state.user_created.group_fullname?.length > 35) ?
                  <div className='zpoll_item_creator-name'> {subString(vm.state.user_created.group_fullname, 35)}</div> :
                  <div className='zpoll_item_creator-name'>{vm.state.user_created.group_fullname}</div>
                }

                <div className='zpoll_list_item_title'>
                  <div className='zlist-poll-item-icon-place'><img src={changeColorSVG('./images/default/static/icon-poll.svg')} alt='' className='zlist-poll-item-icon'  /></div>
                  <div className='zlist-poll-item-txt-place'>{translate('Poll')}</div>
                </div>
              </div>
            </div>
          </div>
          <div className='zpoll_item_creator-devide'></div>
        </div>  */}
        </div>
      }
      <div className='zlist-poll-item-content'>
          <RxPollItem comp={'poll_list_item'} pollInfo={vm.props.pollInfo} token={vm.token} choosePoll={(pollInfo)=>{vm.choosePoll(pollInfo)}}/>
      </div>
      <div className='zlist-poll-item-footer'>
        {/* <div className='zlist-poll-item-txt-time'>{ translate('Creation time')+': ' +autoConvertTime(rxaget(pollInfo, 'created_at', '')) +' | '}</div> */}
        {/* <div className='zpoll_mess_button_place'>
          <div className='zpoll_mess_button'>{translate('Poll')}</div>
        </div> */}

      </div>
    </div>
  )
}
